"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MBReportType;
(function (MBReportType) {
    MBReportType["FEDERAL"] = "federal";
    MBReportType["LGCA"] = "lgca";
})(MBReportType = exports.MBReportType || (exports.MBReportType = {}));
//# sourceMappingURL=Compliance.js.map